import { Controller } from '@hotwired/stimulus';
import { PasswordInputController } from '@elc-online/edl-components/js/password_input';
import { SwitchEventDetails } from './switch-controller';

export default class extends Controller<HTMLElement> {
  static readonly targets = ['input'];

  declare inputTarget: HTMLInputElement;

  private edlController: PasswordInputController;

  initialize() {
    this.edlController = new PasswordInputController(
      {
        input: this.inputTarget,
      },
      {
        mode: 'auto',
      },
    );
  }

  onSwitchToggle = (event: CustomEvent<SwitchEventDetails>): void => {
    this.edlController.togglePassword(event.detail.isChecked);
  }
}
